import { LocationLandingLayout, LocationPageContent } from './LocationLandingLayout'

const content: LocationPageContent = {
  locale: 'tr',
  slug: 'istanbul-bakirkoy-performans-pazarlama-ajansi',
  meta: {
    title: 'İstanbul Bakırköy Performans Pazarlama Ajansı | Thinklyze',
    description:
      'Bakırköy\'deki işletmeler için Google Ads, Meta Ads ve performans odaklı dijital pazarlama. Ölçülebilir sonuçlar, şeffaf raporlama.',
    keywords: [
      'Bakırköy performans pazarlama',
      'Bakırköy dijital pazarlama ajansı',
      'Bakırköy Google Ads',
      'Bakırköy reklam ajansı',
      'performans pazarlama Bakırköy',
      'istanbul bakirkoy dijital ajans',
    ],
    canonical: 'https://thinklyze.com/istanbul-bakirkoy-performans-pazarlama-ajansi',
  },
  hero: {
    badge: 'Bakırköy Performans Pazarlama',
    title: 'Bakırköy\'deki İşletmeniz için Ölçülebilir Dijital Büyüme',
    subtitle:
      'Bakırköy\'ün yoğun rekabet ortamında öne çıkmak için veri odaklı performans pazarlama stratejileri. Google Ads, Meta Ads ve çok kanallı kampanyalarla hedef kitlenize en doğru anda ulaşın.',
    stats: [
      { value: '%320', label: 'Ortalama ROAS Artışı' },
      { value: '%55', label: 'Düşen Müşteri Edinme Maliyeti' },
      { value: '48sa', label: 'Kampanya Başlatma Süresi' },
    ],
    highlights: [
      {
        title: 'Bakırköy\'e Özel Hedefleme',
        description:
          'Bakırköy ve çevresindeki demografik ve davranışsal verileri kullanarak yalnızca potansiyel müşterilerinize ulaşıyoruz.',
      },
      {
        title: 'Şeffaf Bütçe Yönetimi',
        description:
          'Harcanan her kuruşu raporluyoruz; kampanya bütçenizi nerelere kullandığımızı anlık olarak görebilirsiniz.',
      },
      {
        title: 'Hızlı Kampanya Kurulumu',
        description:
          'Onay aldıktan sonra 48 saat içinde kampanyaları devreye alıyor, ilk verileri sizinle paylaşıyoruz.',
      },
    ],
  },
  problemSolution: {
    title: 'Bakırköy İşletmelerinin Reklamcılıkta Yaşadığı Sorunlar',
    subtitle: 'Yerel rekabette geride kalmamak için bu engelleri aşıyoruz.',
    items: [
      {
        title: 'Reklam harcamaları sonuç getirmiyor',
        description:
          'Hedefleme hatası, zayıf reklam metni veya kötü optimize edilmiş kampanya yapısı nedeniyle bütçe boşa akıyor. Hesap denetimiyle sorunları tespit ediyor ve düzeltiyoruz.',
      },
      {
        title: 'Rakipler her zaman önde görünüyor',
        description:
          'Bakırköy\'deki rakipleriniz arama sonuçlarının tepesinde yer alıyor; siz görünmüyorsunuz. Akıllı teklif stratejileri ve negatif anahtar kelime yönetimiyle dengeyi sizin lehinize çeviriyoruz.',
      },
      {
        title: 'Tıklama var, müşteri yok',
        description:
          'Yüksek tıklama ama düşük dönüşüm oranı; genellikle landing page sorunudur. CRO testleriyle sayfalarınızı dönüşüm makinesi haline getiriyoruz.',
      },
      {
        title: 'Hangi kampanya işe yarıyor bilmiyorum',
        description:
          'Conversion tracking olmadan karar vermek körleyin bisiklet sürmek gibidir. GA4 ve enhanced conversions kurulumunu eksiksiz yapıyor, verileri yorumluyoruz.',
      },
    ],
  },
  services: {
    title: 'Bakırköy için Performans Pazarlama Hizmetleri',
    items: [
      {
        title: 'Google Search Reklam Yönetimi',
        description:
          'Bakırköy\'de ürün veya hizmetinizi arayan kişilere tam doğru anda göründüğünüzden emin oluyoruz.',
      },
      {
        title: 'Meta (Facebook & Instagram) Reklamları',
        description:
          'Bakırköy\'deki hedef kitleye yaş, ilgi alanı, konum ve davranış bazlı hassas segmentasyonla ulaşıyoruz.',
      },
      {
        title: 'Google Shopping Kampanyaları',
        description:
          'E-ticaret işletmeleri için ürün görsellerini ve fiyatları öne çıkaran alışveriş reklamları.',
      },
      {
        title: 'Retargeting Kampanyaları',
        description:
          'Sitenizi ziyaret edip satın almayan kullanıcıları dinamik içeriklerle yeniden hedefleyin.',
      },
      {
        title: 'Kampanya Denetimi & Optimizasyon',
        description:
          'Mevcut reklam hesabınızı analiz ediyor, kayıp alanları kapatıyor ve verimliliği artırıyoruz.',
      },
      {
        title: 'Conversion Tracking & Analytics',
        description:
          'GA4, Facebook Pixel ve server-side tracking entegrasyonuyla ölçüm altyapınızı sağlam temele oturtuyoruz.',
      },
    ],
  },
  locationBenefits: {
    title: 'Neden Bakırköy\'deki Thinklyze ile Çalışmalısınız?',
    items: [
      {
        title: 'Bakırköy Merkezli Ofis',
        description:
          'Bakırköy\'de fiziksel olarak bulunuyoruz. Müşterilerimizle yüz yüze buluşmak bizim için kolaylık.',
      },
      {
        title: 'Yerel Rakip Takibi',
        description:
          'Bakırköy\'deki doğrudan rakiplerinizin reklam stratejilerini izliyor, boşluklardan faydalanıyoruz.',
      },
      {
        title: 'Hızlı Yanıt Süresi',
        description:
          'Aynı şehir, aynı saat dilimi. İstekte bulunduğunuz anda geri dönüş sağlıyoruz.',
      },
      {
        title: 'KOBİ ve Büyük İşletme Deneyimi',
        description:
          'Bakırköy\'deki küçük butik işletmelerden büyük zincir mağazalara kadar geniş yelpazede deneyimimiz var.',
      },
      {
        title: 'Sertifikalı Google & Meta Uzmanları',
        description:
          'Google Partner ve Meta Business Partner olarak en güncel platform değişikliklerinden haberdarız.',
      },
      {
        title: 'Özelleştirilmiş Raporlama',
        description:
          'Sizin için önemli KPI\'lara odaklanan, anlaşılır dil kullanan raporlar hazırlıyoruz.',
      },
    ],
  },
  process: {
    title: 'Performans Pazarlama Sürecimiz',
    items: [
      { title: 'Hesap Denetimi', description: 'Mevcut kampanyaları, bütçe dağılımını ve dönüşüm izlemesini gözden geçiriyoruz.' },
      { title: 'Strateji Geliştirme', description: 'Bakırköy pazarına özel kanal planı, hedef kitle tanımı ve bütçe modeli oluşturuyoruz.' },
      { title: 'Kampanya Kurulumu', description: 'Yapılandırmadan reklam metinlerine, görsellere kadar her şeyi hazırlıyoruz.' },
      { title: 'Sürekli Optimizasyon', description: 'Günlük bid ayarlamaları, A/B testleri ve haftalık raporlarla büyüyoruz.' },
    ],
  },
  faqs: [
    {
      question: 'Bakırköy\'de bir işletme için aylık reklam bütçesi ne olmalı?',
      answer:
        'Sektöre ve rekabete göre değişir. Bakırköy için tipik bir başlangıç bütçesi 5.000–15.000 TL arasındadır. Ücretsiz keşif görüşmesinde size özel bütçe tavsiyesi sunuyoruz.',
    },
    {
      question: 'Kampanya sonuçlarını ne zaman görürüm?',
      answer:
        'İlk 2 haftada veri toplamaya başlarız, 4. haftada anlamlı optimizasyonlar yapılır. Dönüşüm hacmine bağlı olarak 4–8 haftada stabil sonuçlar elde edilir.',
    },
    {
      question: 'Reklam bütçesine ajans ücreti dahil mi?',
      answer:
        'Hayır, reklam harcaması ile yönetim ücreti ayrıdır. Bütçenizin tamamı doğrudan reklam platformuna gider; yönetim hizmeti için ayrı bir ücret alıyoruz.',
    },
  ],
  cta: {
    badge: 'Bakırköy\'de Performans Pazarlama',
    title: 'Reklam Bütçenizin Gerçek Karşılığını Alın',
    description:
      'Mevcut Google veya Meta reklam hesabınızı ücretsiz denetliyoruz. Kayıp alanları, iyileştirme fırsatlarını ve tahmini bütçe tasarrufunu somut verilerle gösteriyoruz.',
  },
  areaServed: ['Bakırköy', 'Bahçelievler', 'Küçükçekmece', 'Zeytinburnu', 'Güngören', 'İstanbul'],
  coordinates: { latitude: 40.9811, longitude: 28.8726 },
  address: {
    streetAddress: 'Zeytinlik Mah. Fişekhane Cad. Carousel No: 5 İç Kapı No: 17',
    addressLocality: 'Bakırköy',
    addressRegion: 'İstanbul',
    postalCode: '34140',
    addressCountry: 'TR',
  },
  relatedServices: {
    title: 'İlgili Hizmetlerimiz',
    items: [
      { name: 'Google Ads Yönetimi', href: '/services/google-ads', description: 'Arama ve Shopping kampanyaları.' },
      { name: 'Meta Ads Yönetimi', href: '/services/meta-ads', description: 'Facebook ve Instagram reklamları.' },
      { name: 'SEO & GEO', href: '/services/seo-geo', description: 'Yerel arama optimizasyonu.' },
      { name: 'Sosyal Medya Yönetimi', href: '/services/social-media', description: 'Marka bilinirliği ve topluluk.' },
    ],
  },
}

const IstanbulBakirkoyPerformansPazarlama = () => {
  return <LocationLandingLayout content={content} />
}

export default IstanbulBakirkoyPerformansPazarlama
